<script setup lang="ts">
  import type { OrderStatusDictionaryRecord } from '@storefront/resources';

  interface Props {
    status: OrderStatusDictionaryRecord;
  }

  defineProps<Props>();
</script>
<template>
  <span class="order-status" :class="status.class">
    {{ status.label }}
  </span>
</template>
<style scoped lang="scss">
  :root {
    --order-status-label-color: var(--color-default);
    --order-status-label-background: var(--color-secondary);
    --order-status-label-radius: 0.625rem;
    --order-status-label-font-size: 0.75rem;
    --order-status-label-padding-y: 0.25rem;
    --order-status-label-padding-x: 0.75rem;

    --order-status-label-color-info: var(--sf-status-color-info);
    --order-status-label-background-info: var(--sf-status-background-info);
    --order-status-label-color-danger: var(--sf-status-color-danger);
    --order-status-label-background-danger: var(--sf-status-background-danger);
    --order-status-label-color-warning: var(--sf-status-color-warning);
    --order-status-label-background-warning: var(--sf-status-background-warning);
    --order-status-label-color-severe: var(--sf-status-color-severe);
    --order-status-label-background-severe: var(--sf-status-background-severe);
    --order-status-label-color-success: var(--sf-status-color-success);
    --order-status-label-background-success: var(--sf-status-background-success);
  }

  .order-status {
    display: inline-block;
    background-color: var(--order-status-label-background);
    color: var(--order-status-label-color);
    border-radius: var(--order-status-label-radius);
    font-size: var(--order-status-label-font-size);
    padding: var(--order-status-label-padding-y) var(--order-status-label-padding-x);
    font-weight: var(--font-weight-bold);

    &.cancelled,
    &.payment-failed {
      background: var(--order-status-label-background-danger);
      color: var(--order-status-label-color-danger);
    }

    &.completed,
    &.dispatched,
    &.payment-paid,
    &.ready-for-collection {
      background: var(--order-status-label-background-success);
      color: var(--order-status-label-color-success);
    }

    &.draft,
    &.new,
    &.offer,
    &.payment-pending,
    &.processing,
    &.processing-collection,
    &.ready-for-dispatch,
    &.unknown {
      background: var(--order-status-label-background-info);
      color: var(--order-status-label-color-info);
    }

    &.payment-on-hold,
    &.processing-on-hold {
      background: var(--order-status-label-background-warning);
      color: var(--order-status-label-color-warning);
    }
  }
</style>
